var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableFilterDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "white",
    stroke: "#5F5F5F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12L11.3971 5.25H3.60289L7.5 12Z",
    fill: "#3B0532"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableFilterDropdownIcon);
export default __webpack_public_path__ + "static/media/table-filter-dropdown-icon.313bf019328fb8c06399aa48da994652.svg";
export { ForwardRef as ReactComponent };